var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"monitorIfScrolledImage",attrs:{"data-animation":"offset"}},[_c('UIImage',_vm._b({staticClass:"image",class:_vm.currentClass},'UIImage',(_vm.$props, _vm.$attrs),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }